import { isArray, toString } from 'lodash';
import { AnalyticsArticleSearch } from '../../interfaces/analyticsArticleSearch';

/*
 * Private helper functions
 */

const buildKeyword = (keyword: string | string[]) => {
  return isArray(keyword) ? keyword.join(',') : toString(keyword);
};

const buildLocationType = (locationType: string) => {
  if (!locationType) return '';
  const LOCATION_TYPE: Record<string, string> = {
    METRO_STATION: 'Trainline',
    DISTRICT: 'District',
    ZONE: 'Zone',
    ROAD: 'Road',
  };
  return LOCATION_TYPE[locationType.toUpperCase()] || '';
};

const build = (articleSearch = {} as AnalyticsArticleSearch) => {
  const {
    keyword,
    projectName,
    locationType,
    locationName,
    selectedMaxValue,
    selectedMinValue,
    priceSegment,
  } = articleSearch;

  return {
    articleSearch: {
      section: '',
      keyword: buildKeyword(keyword),
      locationType: buildLocationType(locationType),
      location: locationName || '',
      project: projectName || '',
      maxPrice: selectedMaxValue || '',
      minPrice: selectedMinValue || '',
      priceSegment: priceSegment || '',
    },
  };
};

export default {
  build,
};
